export default {"src":"/_next/static/media/stackoverflow.bfa91403.svg","height":124,"width":622,"blurWidth":0,"blurHeight":0};